export type ExpiryDayConvention = "first" | "last";

export function resolveExpiryDate(
  month: number,
  year: number,
  convention: ExpiryDayConvention = "last",
): Date {
  if (convention === "last") return new Date(year, month, 0);
  return new Date(year, month - 1, 1);
}

export function formatExpiryDate(
  month: number,
  year: number,
  convention: ExpiryDayConvention = "last",
): string {
  void convention;
  // Product rule: show month-end expiry date in UI consistently.
  const date = resolveExpiryDate(month, year, "last");
  const label = date.toLocaleDateString("en-ZA", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return label;
}
